import React from 'react'

import { IJersey } from 'protos'

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'

import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'
import Jersey from 'components/Jersey'
import { createStyles, Theme } from '@material-ui/core'

interface Props {
  jersey?: IJersey | null
  label?: React.ReactNode | string
  name?: React.ReactNode | string | null
}

const styles = (theme: Theme) =>
  createStyles({
    avatar: {
      backgroundColor: theme.palette.common.white,
      borderColor: theme.palette.grey['50'],
      borderStyle: 'solid',
      borderWidth: 1,
      marginBottom: theme.spacing() * 2,
    }
  })

type InjectedProps = Props & WithStyles<typeof styles>

const MostSelectedItem: React.SFC<InjectedProps> = ({
  classes,
  jersey,
  label,
  name
}) => (
  <Grid item>
    <Grid direction="column" alignItems="center" container>
      <Grid item>
        <Avatar className={classes.avatar}>
          <Jersey jersey={jersey || {}} />
        </Avatar>
      </Grid>
      <Grid item>
        <Typography variant="caption">{label}</Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle2">{name}</Typography>
      </Grid>
    </Grid>
  </Grid>
)

MostSelectedItem.defaultProps = {
  name: <T id="topplayers_emptymessage" />
}

export default withStyles(styles)(MostSelectedItem)
